<svelte:head>
  <title>{title} | WAD Report Tool</title>
</svelte:head>

<div class="page-content" id="{pageid}" lang={deutsch ? 'de' : null}><!-- FFG: if variable deutsch is set, set lang="de" -->
{#if needsPanelSpace}
  <div class="default-grid">
    <main class="main-with-panel">
      <h1>{title}</h1>
      <slot />
    </main>
    <YourReport />
  </div>
{:else}
  <div class="default-grid">
    <main class="main-without-panel">
      {#if !noReportPage && !isViewReport && !isOverview}
      <YourReport />
      {/if}
      <h1>{title}</h1>
      <slot />
    </main>
  </div>
{/if}
</div>

<style>
  .page-content {
    padding: 2em 0;
  }
  .main-with-panel {
    grid-column: 2 / 8;
  }
  .main-without-panel {
    grid-column: 2 / 10;
  }
  :global(main > *:not(:last-child)) {
    margin-bottom: 1em;
  }
</style>

<script>
  import { onMount } from "svelte";
  import { useLocation } from 'svelte-navigator';
  import { honourFragmentIdLinks } from '@app/scripts/honourFragmentIdLinks.js';

  import { routes, yourReportPanelOpen } from '@app/stores/appStore.js';

  import YourReport from '@app/components/ui/YourReport.svelte';

  const location = useLocation();

  export let pageid;

  $: isViewReport = $location.pathname === $routes.VIEW_REPORT.path;
  $: isOverview = $location.pathname === $routes.OVERVIEW.path;
  // FFG: additional pages that don't require a "YourReport Panel"
  $: noReportPage = /*$location.pathname === $routes.ACKNOWLEDGEMENTS.path ||*/ $location.pathname === $routes.FFG_AUDIT.path;
  $: needsPanelSpace = !noReportPage && !isViewReport && !isOverview && $yourReportPanelOpen;

  onMount(() => {
    setTimeout(honourFragmentIdLinks($location), 100);
  });

  export let title;
  export let deutsch = undefined;
</script>
